import React from 'react';
import { Box } from '@mui/material';

import useScreenSize from '../../utils/useScreenSize';
import OwnCollectionOverviewMainContent from './OwnCollectionOverviewMainContent';
import OwnCollectionOverviewWatchlist from './OwnCollectionOverviewWatchlist';
import { customSizes } from '../../assets/styles/themes/tokens';
import { Collection, Pagination } from '../../types/AppContent';
import { AsyncActionStatus } from '../../actions/common.actionTypes';

interface OwnCollectionOverviewBodyProps {
  collectionStatus: AsyncActionStatus;
  collection: Collection;
  collectionId: string;
  collectionPagination: Pagination;
  loadNext: () => void;
}

const OwnCollectionOverviewBody = ({
  collectionStatus,
  collection,
  collectionId,
  collectionPagination,
  loadNext,
}: OwnCollectionOverviewBodyProps) => {
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isMobileScreen = isXsScreen || isSmScreen;

  return (
    <Box
      sx={{
        height: customSizes.ownCollectionOverview.bodyHeight,
        display: 'grid',
        gridTemplateColumns: (isMobileScreen) ? '1fr' : `1fr ${customSizes.ownCollectionOverview.watchlistWidth}`,
      }}
    >
      <OwnCollectionOverviewMainContent
        collection={collection}
        collectionStatus={collectionStatus}
        collectionId={collectionId}
        collectionPagination={collectionPagination}
        loadNext={loadNext}
      />
      {!isMobileScreen && <OwnCollectionOverviewWatchlist collection={collection} />}
    </Box>
  );
};

export default OwnCollectionOverviewBody;
